// extracted by mini-css-extract-plugin
export default {"sortIconOnly":"tfKP3sDXFvUFS0ESVrRw"};